import { useRef } from "react"

import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

import { AlertContainer, IconContainer } from "../../style"
import { IoAlertCircleOutline } from "@react-icons/all-files/io5/IoAlertCircleOutline"
import { ManagerDataDialog } from "../dialog"

import Button from "@core/design-system/button"
interface IManagerDataAlert {
  hasComplementaryData?: boolean;
}

export const ManagerDataAlert = ({ hasComplementaryData }: IManagerDataAlert) => {
  if (!hasComplementaryData) return null;
  const dialogRef = useRef(null);

  const handleOpenDialog = () => {
    dialogRef.current.handleOpenDialog();
  }

  return (
    <>
      <AlertContainer>
        <Stack direction="row" alignItems="center" gap={2}>
          <IconContainer>
            <IoAlertCircleOutline size={16} />
          </IconContainer>

          <Typography>
            <strong style={{ marginRight: '4px' }}>
              Importante:
            </strong>
            As informações desta página contém dados complementares e/ou editados enviados pelo gestor responsável pelo fundo.
          </Typography>

          <Button
            variant="outlined"
            color="primary"
            onClick={handleOpenDialog}
            sx={{
              borderRadius: '24px',
              marginLeft: 2
            }}
          >
            Saiba mais
          </Button>
        </Stack>
      </AlertContainer>

      <ManagerDataDialog ref={dialogRef} />
    </>
  )
}